import cn from 'classnames'
import type { MotionProps } from 'framer-motion'
import { motion } from 'framer-motion'
import React from 'react'

import type { AccountMock } from 'components/uiKit/Employee'
import Employee from 'components/uiKit/Employee'
import type { KeyIconsType } from 'components/uiKit/Icon'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'

import * as s from './CanvasBubble.module.scss'

interface ICanvasBubbleProps {
  active?: boolean
  isNew?: boolean
  isResolved?: boolean
  onClick?: () => void
  icon?: KeyIconsType
  count?: number
  employee?: AccountMock | null
  animation?: boolean
}

const CANVAS_COMMENT_WHILE_HOVER: MotionProps['whileHover'] = {
  scale: 1.1,
}

const CanvasBubble: React.FC<ICanvasBubbleProps> = ({
  count,
  icon,
  employee,
  active,
  isNew,
  isResolved,
  onClick,
  animation,
}) => {
  return (
    <motion.div
      className={cn(s.root, { [s.active]: active, [s.resolved]: isResolved })}
      onClick={onClick}
      whileHover={animation ? CANVAS_COMMENT_WHILE_HOVER : undefined}
    >
      <div className={s.content}>
        {icon && <Icon name={icon} size={KitSize.S} />}
        {employee && <Employee employee={employee} styleType='avatar' />}
        {Boolean(count) && <div className={s.count}>{count}</div>}
        {isNew && <div className={s.newDot} />}
      </div>
    </motion.div>
  )
}

export default CanvasBubble
